import {observable} from "mobx"

class HeaderStore {
  @observable header = null
}

const store = new HeaderStore()
export default store


// WEBPACK FOOTER //
// ./src/stores/HeaderStore.js